import { Modal } from "Components/Modals/Modal";
import Warning from "Assets/Images/atention.svg";
import { Box } from "styles/globalComponents";
import { Button } from "Components/Button";
import { useMutation } from "react-query";
import { createToast } from "Utils/toastFunc";
import { cancelPartperAPI } from "Requests/SchedulePartners";

interface CancelModalProps {
  isOpen: boolean;
  requestClose: () => void;
  refetch: () => void;
  acuityId: number;
}

export const CancelOrderModal = ({
  isOpen,
  refetch,
  requestClose,
  acuityId,
}: CancelModalProps) => {
  const cancelScheduleMutation = useMutation({
    mutationFn: cancelPartperAPI,
  });

  const cancelSchedule = async () => {
    try {
      await cancelScheduleMutation.mutateAsync(acuityId);
      refetch();
      createToast("success", "Agendamento cancelado com sucesso");
      requestClose();
    } catch (error: any) {
      if (error?.response?.data?.error) {
        createToast("error", error?.response?.data?.error);
      }
    }
  };

  return (
    <Modal
      closeOverlay={false}
      isOpen={isOpen}
      requestClose={requestClose}
      modalIcon={Warning}
      renderHeading={() => (
        <h2 style={{ textAlign: "center" }}>Cancelar agendamento</h2>
      )}
      renderActions={() => (
        <Box display="flex" direction="column">
          <p
            style={{
              marginBottom: "-1.5em",
              color: "var(--color-hgray-text)",
              textAlign: "center",
              fontFamily: "var(--font-text)",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "160%",
              margin: "0px",
            }}
          >
            <strong>Atenção</strong>
            <br />
            Está ação não poderá ser desfeita. <br />
            Deseja continuar ?
          </p>

          <Button
            width="full"
            minHeight="3.7em"
            fontWeight="600"
            onClick={cancelSchedule}
            loading={cancelScheduleMutation.isLoading}
            disabled={cancelScheduleMutation.isLoading}
          >
            Prosseguir com o Cancelamento
          </Button>

          <Button
            width="full"
            outlined
            minHeight="3.7em"
            fontWeight="600"
            loading={cancelScheduleMutation.isLoading}
            disabled={cancelScheduleMutation.isLoading}
            onClick={requestClose}
          >
            Voltar para detalhes
          </Button>
        </Box>
      )}
    />
  );
};
